/**
 * Code ownership: Organic growth
 */

export type ContentTypography = object;

export const contentTypography: ContentTypography = {};
